import { Directive, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appMention]'
})
export class MentionDirective {
  @Output() mentionTriggered = new EventEmitter<string>();

  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    const input = (event.target as HTMLElement).innerText;
    const mentionMatch = input.match(/@(\w+)$/);
    if (mentionMatch) {
      this.mentionTriggered.emit(mentionMatch[1]);
    }
  }
}
